import axios from "axios";
import { Cloud_API_URL } from "./constants";

const { REACT_APP_API_URL } = process.env;

export const getAllUsers = async () => {
  try {
    let res = await axios.get(REACT_APP_API_URL + `/admin/getAllUsers`);
    return res.data;
  } catch (error) {
    console.log(error);
  }
};
export const updateUserFlag = async (id, flag) => {
  try {
    const response = await axios.put(
      `${Cloud_API_URL}/user/${id}/update-field`,
      { field: "change_flag", value: flag },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    console.log("Flag updated:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error updating flag:", error.message);
    throw error;
  }
};

export const updateHasDoubleVision = async (id, value) => {
  try {
    const response = await axios.put(
      `${Cloud_API_URL}/user/${id}/update-field`,
      { field: "has_double_vision", value },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating has_double_vision flag:", error);
    throw error;
  }
};

export const getAdditionalUserInfo = async (uuid) => {
  try {
    const response = await axios.get(
      `${Cloud_API_URL}/user/get-additional-info`,
      {
        params: { uuid },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching additional user info:", error);
    return null;
  }
};
export const getTeacherInfoForStudent = async (uuid) => {
  try {
    const response = await axios.get(`${Cloud_API_URL}/user/teachers`, {
      params: { uuid },
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching additional user info:", error);
    return null;
  }
};
// Function to update the starred flag for a user
export const updateStarredFlag = async (userUuid, starred) => {
  try {
    const response = await axios.put(
      `${Cloud_API_URL}/user/${userUuid}/update-field`,
      {
        field: "starred",
        value: starred,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    console.log("Update starred flag response:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error updating starred flag:", error);
    throw error;
  }
};
